import React from 'react'
import styled from 'styled-components'

type ClipProps = {
  src: string
  height?: string
  width?: string
}

export const GIF = styled.img`
  width: 100%;
  margin-bottom: 50px;
  height: ${({ height = 'initial' }) => height};
`

export const ClipsContainer = styled.div`
  display: flex;
  margin-bottom: 50px;

  & > *:not(:last-child) {
    margin-right: 10px;
  }
`

const ClipWrapper = styled.div<{ width?: string; height?: string }>`
  height: ${({ height }) => height};
  width: ${({ width = '100%' }) => width};
`

export const Clip: React.FC<ClipProps> = (props) => {
  const { src, height, width } = props
  return (
    <ClipWrapper height={height} width={width}>
      <iframe title={`Clip ${src}`} frameBorder="0" height={height} src={src} width="100%" />
    </ClipWrapper>
  )
}
